import { IUpdateOrganizationUserPayload, IUserOutputDto } from '@quadminds/shared/auth-system';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

/**
 * Hook para actualizar un usuario de la organización.
 *
 * @returns La mutation para actualizar el usuario.
 */
interface UseUpdateOrganizationUserVariables {
    organizationId: string;
    userId: string;
    payload: IUpdateOrganizationUserPayload;
}

export const useUpdateOrganizationUser = (): UseMutationResult<
    IUserOutputDto,
    Error,
    UseUpdateOrganizationUserVariables
> => {
    return useMutation<IUserOutputDto, Error, UseUpdateOrganizationUserVariables>({
        mutationFn: async ({ organizationId, userId, payload }: UseUpdateOrganizationUserVariables) => {
            if (!organizationId || !userId) {
                throw new Error('Organization ID y User ID son requeridos para actualizar un usuario');
            }
            const response = await usersApi.updateOrganizationUsers(organizationId, userId, payload);
            return response.data;
        },
    });
};
